const constants = require('../../../lib/constants');
const baseEventHandler = require('./base');
const { get } = require('lodash');

// we are given access to base event handlers with 'baseEventHandler' via the q.defer({}) method used in async-loader.js
const EventHandlers = {
    handleChangeOnBusinessType(ev, element, ctx, ...elementNames) { 
        const page = get(ctx, 'form.activePage');
        const fieldName = get(element, 'attributes.name');
        const bizType = get(ctx, `data.fields['${fieldName}'].value`);
        if (elementNames.length > 0) {
            if (bizType) {
                elementNames.forEach((elementName) => {
                    baseEventHandler.show(elementName, ctx);
                    ctx.dataActions.updateField(elementName, '');
                });
            } else {
                elementNames.forEach((elementName) => {
                    baseEventHandler.hide(elementName, ctx);
                });
            }
        }

        if (constants.NON_ENTITY_BUSINESS_TYPES.includes(bizType)) {
            baseEventHandler.hide('businessIncorporationQuestion', ctx);
            baseEventHandler.hide('businessEstablishedDate', ctx);
            baseEventHandler.hide('businessRegistrationNumberQuestion', ctx);
            baseEventHandler.hide('businessRegistrationNumber', ctx);
            baseEventHandler.disableValidations('businessEstablishedDate', ctx);
            baseEventHandler.disableValidations('businessCountryOfIncorporation', ctx);
            ctx.dataActions.updateFieldWithErrors('businessCountryOfIncorporation', []);
            if (bizType === 'PROPRIETORSHIP') {
                ctx.formActions.updateElementProperty(page, 'businessCountryOfIncorporation', 'floatingLabel', 'fields.businessCountryOfIncorporationOptional.placeholder');
                ctx.dataActions.updateField('businessCountryOfIncorporation', '');
            } else {
                baseEventHandler.hide('businessCountryOfIncorporation', ctx);
            } 
        } else {
            baseEventHandler.enableValidations('businessCountryOfIncorporation', ctx);
            ctx.formActions.updateElementProperty(page, 'businessCountryOfIncorporation', 'floatingLabel', 'fields.businessCountryOfIncorporation.placeholder');
            baseEventHandler.enableValidations('businessEstablishedDate', ctx);
            ctx.dataActions.updateField('businessCountryOfIncorporation', ctx.content && ctx.content.countryCode);
        }
    },
    handleChangeOnCountryOfIncorporation(ev, element, ctx) {
        const userCountryCode = get(ctx, 'content.countryCode');
        if (userCountryCode && ev && ev !== userCountryCode) {
            baseEventHandler.hide('businessRegistrationNumberQuestion', ctx);
            baseEventHandler.hide('businessRegistrationNumber', ctx);
            ctx.dataActions.updateField('businessRegistrationNumber', '');
        } else if (userCountryCode && ev && ev === userCountryCode) {
            baseEventHandler.show('businessRegistrationNumberQuestion', ctx);
            baseEventHandler.show('businessRegistrationNumber', ctx);
        }
    },
    handleChangeOnIdentityDocumentType(ev, element, ctx) {
        let page = get(ctx, 'form.activePage'),
            fields = get(ctx, 'data.fields'),
            identityDocumentType = fields[element.attributes.name],
            identityDocumentTypeValue = identityDocumentType && identityDocumentType.value,
            floatingLabel = 'fields.identityDocumentValue.' + identityDocumentTypeValue;

        if (identityDocumentTypeValue) {
            // show the identity type textbox
            baseEventHandler.show('identityDocumentValue', ctx);
            // enable the validations
            baseEventHandler.enableValidations('identityDocumentValue', ctx);
            // add the appropriate floatingLabel
            ctx.formActions.updateElementProperty(page, 'identityDocumentValue', 'floatingLabel', floatingLabel);

        } else {
            // hide the identity type textbox
            baseEventHandler.hide('identityDocumentValue', ctx);
            // disable the validations
            baseEventHandler.disableValidations('identityDocumentValue', ctx);
        }
    }
};

module.exports = EventHandlers;